import { Switch } from 'react-aria-components';

export default function TOGGLE({ checked = false, disabled = false, label, onChange }) {
    return (
        <Switch
            className='toggle'
            isDisabled={disabled}
            isSelected={checked === true}
            onChange={onChange}
        >
            <span className='toggle__track' aria-hidden='true'>
                <span className='toggle__thumb' />
            </span>
            <span className='field__label text--sm medium'>{label}</span>
        </Switch>
    );
}